/* eslint-disable */
// Placeholder so webpack can resolve ./aws-config. Overwritten by
// infra/scripts/generate-aws-config.js for sandbox builds. null → App.js uses amplifyConfig.
export default null;
